import { RecordUtils } from "@rsm-hcd/javascript-core";
import { CodeReferenceBlockConfigurationRecord } from "models/view-models/block-configurations/code-reference-block-configuration-record";
import { BlockRecord } from "models/view-models/block-record";
import SectionRecord from "models/view-models/section-record";
import { useCallback, useEffect, useMemo, useState } from "react";
import useCodeReferenceBlockSectionApi from "utilities/hooks/domain/block-configurations/use-code-reference-block-section-api";

interface UseCodeReferenceBlockSection {
    section: SectionRecord | null;
}

export const useCodeReferenceBlockSection = (
    block: BlockRecord
): UseCodeReferenceBlockSection => {
    const sectionId = useMemo(() => {
        const config = RecordUtils.ensureRecord(
            block.configuration,
            CodeReferenceBlockConfigurationRecord
        );
        return config.sectionId;
    }, [block.configuration]);
    const { getCodeReferenceSection, setLoadingCodeReference } =
        useCodeReferenceBlockSectionApi();

    const [section, setSection] = useState<SectionRecord | null>(null);

    const loadSection = useCallback(async () => {
        setLoadingCodeReference(true);
        const loadedSection = await getCodeReferenceSection(sectionId);

        setSection(loadedSection ?? null);
        setLoadingCodeReference(false);
    }, [getCodeReferenceSection, sectionId, setLoadingCodeReference]);

    useEffect(() => {
        loadSection();
    }, [loadSection]);

    return { section: section };
};
